import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import axios from "axios";
import { API, useAuth } from "../AuthContext";
import { useI18n } from "../i18n";
import { Header } from "../components/Frumy";
import { Crown, Check, Lock, ArrowRight, ShieldCheck } from "@phosphor-icons/react";

export default function Pro() {
  const { user } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);

  const pay = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/payments/checkout`, { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) { toast.error(e.response?.data?.detail || "Errore pagamento"); setLoading(false); }
  };

  if (user?.is_pro) {
    return (
      <div className="min-h-screen"><Header />
        <div className="max-w-xl mx-auto px-4 py-24 text-center">
          <span className="inline-grid place-items-center h-16 w-16 rounded-full bg-[var(--frumy-lock)] text-white mb-6">
            <Crown weight="fill" size={30} aria-hidden />
          </span>
          <h1 className="font-display text-3xl font-extrabold">{t("proActive")}</h1>
          <button data-testid="to-dashboard-btn" onClick={() => nav("/dashboard")}
            className="pill-btn cta-metal mt-8 inline-flex items-center gap-2 text-white font-bold px-6 py-3">
            {t("goToDashboard")}<ArrowRight weight="bold" size={18} aria-hidden />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen"><Header />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.2em] uppercase font-bold text-[var(--frumy-lock)]">
            <Crown weight="fill" size={16} aria-hidden />Frumy Pro
          </span>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-4">{t("proTitle")}</h1>
          <p className="text-[var(--text-muted)] mt-3">{t("proSub")}</p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: .1 }}
          className="frumy-card p-8 mt-10 relative overflow-hidden">
          <div className="flex items-end gap-2">
            <span className="font-display text-5xl font-extrabold">9,99 €</span>
            <span className="text-sm font-bold text-[var(--text-muted)] mb-2 uppercase tracking-wider">/ {t("oneTime")}</span>
          </div>
          <ul className="space-y-3 mt-8">
            {t("proFeatures").map((f, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="grid place-items-center h-6 w-6 rounded-full bg-emerald-100 text-[var(--frumy-green)] shrink-0 mt-0.5">
                  <Check weight="bold" size={14} aria-hidden />
                </span>
                <span className="text-sm font-medium text-[var(--heading)]">{f}</span>
              </li>
            ))}
          </ul>
          <button data-testid="stripe-pay-btn" onClick={pay} disabled={loading}
            className="pill-btn w-full flex items-center justify-center gap-2 bg-[var(--frumy-lock)] hover:brightness-95 text-white font-bold py-4 mt-8 disabled:opacity-60">
            {loading ? "..." : <><Lock weight="fill" size={18} aria-hidden />{t("payNow")}</>}
          </button>
          <p className="flex items-center justify-center gap-1.5 text-xs text-slate-400 mt-4">
            <ShieldCheck size={14} aria-hidden />Pagamento sicuro con Stripe · Nessun rinnovo automatico
          </p>
        </motion.div>
      </div>
    </div>
  );
}
